import type { ProjectListItem } from '../../api/types'

export type CategoryGroup = { category: string; value: number; projects: ProjectListItem[] }

/** Groups projects by category, biggest category first (for the treemap). */
export function groupByCategory(projects: ProjectListItem[]): CategoryGroup[] {
  const groups = new Map<string, ProjectListItem[]>()
  for (const p of projects) {
    const key = p.category ?? 'Not set'
    groups.set(key, [...(groups.get(key) ?? []), p])
  }
  return [...groups]
    .map(([category, list]) => ({ category, projects: list, value: list.reduce((s, p) => s + p.valueRupees, 0) }))
    .sort((a, b) => b.value - a.value)
}

export type Relationship = { id: number; name: string; projects: ProjectListItem[]; value: number }

/** Each stakeholder with the projects (from the list given) they are linked to; most valuable first. */
export function relationships(projects: ProjectListItem[]): Relationship[] {
  const byPerson = new Map<number, Relationship>()
  for (const p of projects) {
    for (const s of p.stakeholders) {
      const r = byPerson.get(s.id) ?? { id: s.id, name: s.name, projects: [], value: 0 }
      r.projects.push(p)
      r.value += p.valueRupees
      byPerson.set(s.id, r)
    }
  }
  return [...byPerson.values()].sort((a, b) => b.value - a.value || b.projects.length - a.projects.length)
}
